import { Component, Input, OnInit } from '@angular/core';
import { DesignPressure } from '../../../models/fitting-query-params.model';

@Component({
  selector: 'app-design-pressures',
  templateUrl: './design-pressures.component.html',
  styleUrls: ['./design-pressures.component.scss']
})
export class DesignPressuresComponent implements OnInit {
  @Input() designPressures: DesignPressure[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
